"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = loadDictionaryTermsSuccess;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _assign = _interopRequireDefault(require("lodash/assign"));
var _transform = _interopRequireDefault(require("lodash/transform"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function doesDictionaryTermMatch(term, value) {
  if (term.isCaseSensitive) {
    if (value.indexOf(term.term) >= 0) {
      return term.priority;
    }
    return -1;
  }
  if (value.toUpperCase().indexOf(term.term.toUpperCase()) >= 0) {
    return term.priority;
  }
  return -1;
}
function loadDictionaryTermsSuccess(state, action) {
  return (0, _transform["default"])(state, function (newState, choice, choiceId) {
    return (
      // eslint-disable-next-line no-param-reassign
      newState[choiceId] = action.data.reduce(function (memo, term) {
        var shortLabelDisplay = choice.siteProductOptionChoiceShortLabel || choice.shortLabel;
        var priority = doesDictionaryTermMatch(term, shortLabelDisplay);
        if (priority >= 0 && (!memo.hasDictionaryTerm || memo.dictionaryTerm.priority < priority)) {
          return (0, _assign["default"])(memo, {
            hasDictionaryTerm: true,
            dictionaryTerm: term
          });
        }
        return memo;
      }, (0, _assign["default"])({}, choice, {
        hasDictionaryTerm: false
      }))
    );
  }, _objectSpread({}, state));
}
//# sourceMappingURL=loadDictionaryTermsSuccess.js.map